(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Measure the header element itself rather than `.section-header`. The
      // header's custom_css makes `.header-wrapper` position:absolute at >=768px,
      // which collapses `.section-header` to 0 height and left --header-height at
      // 0px. In stock Sense the two measure the same value, so this is a no-op there.
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  class SplitHeroVideo extends HTMLElement {
    connectedCallback() {
      this.desktopOnly = this.dataset.desktopOnly === 'true';
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onQueryChange = this.evaluate.bind(this);

      this.desktopQuery.addEventListener('change', this.onQueryChange);
      this.reduceMotionQuery.addEventListener('change', this.onQueryChange);

      this.evaluate();
    }

    disconnectedCallback() {
      this.desktopQuery.removeEventListener('change', this.onQueryChange);
      this.reduceMotionQuery.removeEventListener('change', this.onQueryChange);
    }

    evaluate() {
      const shouldPlay =
        !this.reduceMotionQuery.matches && (!this.desktopOnly || this.desktopQuery.matches);

      if (shouldPlay) {
        this.mount();
      } else {
        this.unmount();
      }
    }

    mount() {
      if (this.querySelector('video')) return;

      const template = this.querySelector('template');
      if (!template) return;

      this.appendChild(template.content.cloneNode(true));
    }

    unmount() {
      const video = this.querySelector('video');
      if (!video) return;

      video.pause();
      video.remove();
    }
  }

  if (!customElements.get('split-hero-video')) {
    customElements.define('split-hero-video', SplitHeroVideo);
  }

  /*
   * Transparent header over the hero.
   *
   * Adds `header-over-hero` to <body> while an opted-in hero still sits under
   * the header strip, so assets/base.css can drop the header's background and
   * flip the logo/icons to white. Removed once you scroll past the hero.
   *
   * The theme's own `scrolled-past-header` class can't be used for this: the
   * overlay header collapses .section-header to 0 height, so that class fires
   * ~38px into the scroll rather than at the end of the hero.
   */
  (function () {
    const BODY_CLASS = 'header-over-hero';
    let observer = null;
    let resizeTimer = null;

    function headerHeight() {
      const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return parseFloat(raw) || 0;
    }

    function init() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      document.body.classList.remove(BODY_CLASS);

      const main = document.getElementById('MainContent');
      const firstSection = main && main.firstElementChild;
      const hero = firstSection && firstSection.querySelector('[data-header-overlay]');
      if (!hero) return;

      // Opt-in per section: the offset opt-out (data-header-overlay) and the
      // transparent treatment are separate settings.
      if (!hero.hasAttribute('data-transparent-header')) return;

      const height = headerHeight();
      if (!height) return;

      // Observation region = the top `height` strip of the viewport, i.e. the
      // band the header occupies.
      observer = new IntersectionObserver(
        (entries) => {
          document.body.classList.toggle(BODY_CLASS, entries[0].isIntersecting);
        },
        { rootMargin: `0px 0px -${Math.max(0, window.innerHeight - height)}px 0px`, threshold: 0 }
      );

      observer.observe(hero);
    }

    function scheduleInit() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // --header-height is set by StickyHeader, which may upgrade after this runs.
    window.addEventListener('load', init);
    window.addEventListener('resize', scheduleInit);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
